import { Card, CardContent, Stack, Chip, Divider, Typography } from "@mui/material";

// Replace your renderSection for Skill Profiles:
export default function SkillProfileCard({profile}) {
    return (
        <Card key={profile.profileId} sx={{ mb: 2, borderRadius: 2, boxShadow: 2 }}>
            <CardContent>
                <Typography variant="h6">{profile.profileName}</Typography>
                <Typography variant="body2" color="text.secondary" gutterBottom>
                    {profile.profileDescription}
                </Typography>

                <Divider sx={{ my: 1 }} />
                

                <Divider sx={{ my: 1 }} />

                <Stack direction="row" spacing={1} flexWrap="wrap" mt={1}>
                    <Chip label={`Active: ${profile.activeFlag ? "Yes" : "No"}`} size="small" />
                    <Chip
                        label={`Start: ${profile.effectiveStartDate
                                ? new Date(profile.effectiveStartDate).toLocaleDateString()
                                : "N/A"
                            }`}
                        size="small"
                    />
                    <Chip
                        label={`End: ${profile.effectiveEndDate
                                ? new Date(profile.effectiveEndDate).toLocaleDateString()
                                : "N/A"
                            }`}
                        size="small"
                    />
                </Stack>
            </CardContent>
        </Card>
    )
};